import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { DeliveryCheckStatus } from '../../../features/Delivery/models/deliveryCheckStatus';
export interface DeliveryCheckStatusResponse {
  status: string;
  message: string;
  data: DeliveryCheckStatus;
}

const service = {
  checkApprovedDelivery(): Promise<CommonResponse<DeliveryCheckStatus>> {
    const url = `check-approved-delivery`;
    return axiosClient.get(url);
  },
};

export default service;
